import { jsx as _jsx } from "react/jsx-runtime";
import { Base } from '../Base';
import { svgIconStyles } from './SvgIcon.styles';
export const SvgIcon = (props) => {
    const { sx, icon, ...other } = props;
    return (_jsx(Base, { "aria-hidden": true, ...other, sx: [svgIconStyles.host, sx], dangerouslySetInnerHTML: { __html: icon.data } }));
};
